'use strict';

angular.module('mandaeApp')
  .factory('Pagamento', function($rootScope, $state, $q, $timeout, localStorageService, ClienteResource) {

    var user = localStorageService.get('user');

    return {

      criaAtualiza: function(cartao, callback) {
        var cb = callback || angular.noop;
        var deferred = $q.defer();

        ClienteResource.criaCartao({ customerId: user.id }, cartao).$promise
          .then(function(data) {
            deferred.resolve(data);
            return cb(data);
          }).
        catch(function(err) {
          deferred.reject(err);
          return cb(err);
        }.bind(this));

        return deferred.promise;
      },

      busca: function(callback) {
        var cb = callback || angular.noop;
        var deferred = $q.defer();

        ClienteResource.getCartao({ customerId: user.id }).$promise
          .then(function(data) {
            deferred.resolve(data);
            return cb(data);
          }).
        catch(function(err) {
          deferred.reject(err);
          return cb(err);
        }.bind(this));

        return deferred.promise;
      },

      habilita: function(idFormaPagamento, callback) {
        var cb = callback || angular.noop;
        var deferred = $q.defer();

        ClienteResource.habilitaCartao({
            customerId: user.id,
            paymentId: idFormaPagamento
          }).$promise
          .then(function(data) {
            deferred.resolve(data);
            return cb(data);
          }).
        catch(function(err) {
          deferred.reject(err);
          return cb(err);
        }.bind(this));

        return deferred.promise;
      },

      desabilita: function(idFormaPagamento, callback) {
        var cb = callback || angular.noop;
        var deferred = $q.defer();

        ClienteResource.desabilitaCartao({
            customerId: user.id,
            paymentId: idFormaPagamento
          }).$promise
          .then(function(data) {
            deferred.resolve(data);
            return cb(data);
          }).
        catch(function(err) {
          deferred.reject(err);
          return cb(err);
        }.bind(this));

        return deferred.promise;
      }
    };

  });
